import { render, staticRenderFns } from "./FooterDefault.vue?vue&type=template&id=1072a983&"
import script from "./FooterDefault.vue?vue&type=script&lang=js&"
export * from "./FooterDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports